import { Injectable } from '@angular/core';

import {
  InvoiceCreateDTO,
  InvoiceDetailModel,
  InvoiceGetDTO,
  InvoicePaidDTO,
  InvoiceServiceTypeUpdateDTO,
  InvoiceUpdateStatusContractorDTO,
} from './invoice.model';

import { map, Observable } from 'rxjs';
import { ApiResponseModel } from '../../core/api-response.model';
import { BaseCrudService } from '../../services/apps/generic/base.service';
import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class InvoicesService extends BaseCrudService<
  ApiResponseModel<InvoiceGetDTO>,
  InvoiceCreateDTO,
  any,
  any
> {
  constructor() {
    super('/api/invoices');
  }

  getInvoiceById(id: string) {
    return this.http.get<InvoiceDetailModel>(
      `${environment.baseApiUrl}/api/invoices/${id}`
    );
  }

  updateStatusByContractor(payload: InvoiceUpdateStatusContractorDTO) {
    return this.http.put(
      `${environment.baseApiUrl}/api/invoices/employee-status`,
      payload
    );
  }

  share(id: string) {
    return this.http.put(`${environment.baseApiUrl}/api/invoices/status`, {
      id,
      status: 'Sent',
    });
  }

  changeToDraft(id: string) {
    return this.http.put(`${environment.baseApiUrl}/api/invoices/status`, {
      id,
      status: 'Draft',
    });
  }

  approve(id: string) {
    return this.http.put(`${environment.baseApiUrl}/api/invoices/status`, {
      id,
      status: 'Approved',
    });
  }
  reject(
    id: string,
    rejectedStatusComments: string,
    rejectedEmployeeIds: string[]
  ) {
    return this.http.put(`${environment.baseApiUrl}/api/invoices/status`, {
      id,
      status: 'Rejected',
      rejectedStatusComments,
      rejectedEmployeeIds,
    });
  }
  updateInvoiceServices(payload: InvoiceServiceTypeUpdateDTO) {
    return this.http.put<InvoiceDetailModel>(
      `${environment.baseApiUrl}/api/invoices/service-type`,
      payload
    );
  }

  updatePaymentStatus(payload: InvoicePaidDTO) {
    return this.http.put(
      `${environment.baseApiUrl}/api/invoices/payment`,
      payload
    );
  }
}
